import { Route, Routes } from 'react-router-dom';
import Layout from './components/Layout';
import SubLayout from './components/SubLayout';
import PageNotFound from './pages/404';
import CourseDetailsPage from './pages/CourseDetails';
import FailedPage from './pages/Error';
import HomePage from './pages/Home';
import PrivacyPage from './pages/Privacy';
import RefundPage from './pages/Refund';
import SuccessPage from './pages/Success';
import TermsPage from './pages/Terms';

function App() {
  return (
    <div className="App">
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<HomePage />} />
          <Route element={<SubLayout />}>
            <Route path="terms" element={<TermsPage />} />
            <Route path="privacy" element={<PrivacyPage />} />
            <Route path="refund" element={<RefundPage />} />
            <Route path="courses/:courseId" element={<CourseDetailsPage />} />
            <Route path="payment/success" element={<SuccessPage />} />
            <Route path="payment/failed" element={<FailedPage />} />
          </Route>
          <Route path="*" element={<PageNotFound />} />
        </Route>
      </Routes>
    </div>
  );
}

export default App;
